import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MachineProvider } from './context/MachineContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ToastContainer from './components/ToastContainer';
import ProtectedRoute from './components/ProtectedRoute';

import HomePage from './pages/HomePage';
import StockPage from './pages/StockPage';
import MachineDetailPage from './pages/MachineDetailPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminPage from './pages/AdminPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

export default function App() {
  return (
    <MachineProvider>
      <BrowserRouter>
        <div className="app-shell">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/"            element={<HomePage />} />
              <Route path="/stock"       element={<StockPage />} />
              <Route path="/machine/:id" element={<MachineDetailPage />} />
              <Route path="/about"       element={<AboutPage />} />
              <Route path="/contact"     element={<ContactPage />} />
              <Route path="/admin-login" element={<AdminLoginPage />} />
              <Route path="/admin"       element={
                <ProtectedRoute><AdminPage /></ProtectedRoute>
              } />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </main>
          <Footer />
          <ToastContainer />
        </div>
      </BrowserRouter>
    </MachineProvider>
  );
}
